import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.5 6.388c0-1.426 1.529-2.33 2.779-1.643l11.54 6.347c1.295.713 1.295 2.574 0 3.286L7.28 20.726c-1.25.687-2.779-.217-2.779-1.643z",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(SvgComponent);
export const PlaySolidIcon = ForwardRef;